import React, { useState } from "react";
import { Row, Col } from "react-grid-system";
import { ICustomer, ICustomerIscc } from "dataModels/contract";
import { AppUserRole, BadgeStatus, ClientType, DATE_FORMAT, DocumentType, DsLayout, EntityType, IAppUserProfile, ResponseCode, ResponseStatus, RoutePath } from "shared/constants";
import { useTranslation } from "react-i18next";
import { Output, Table } from "@ds/ds-snam/react";
import { getDSTableSharedElements, getTableCellsHeaderSimple } from "shared/utils/dsComponentUtils";
import { getDelegationLegend } from "../shared/listUtils";
import { RootState } from "state/appStore";
import { useDispatch, useSelector } from "react-redux";
import { ITableCell, ITableConfig, ITableRow } from "@ds/ds-snam/dist/models/tables";
import { IParseDateFormatType, parseDateForDS } from "shared/utils/dateUtils";
import moment from "moment";
import useAppUser from "hooks/useAppUser";
import { AppUser } from "ooAuth2/appUser";
import { deleteCustomerISCCDocumentAPI, downloadDocument, putIsccDocumnetStatus, putCustomerISCCDocument } from "net/contracts";
import { INotificationAction } from "dataModels/stateModels/notification";
import { hideNotification, showNotification } from "state/reducer/notificationSlice";
import { useNavigate } from "react-router";
import { saveAs } from "file-saver";
import DialogMessage from "components/DialogMessage";

interface ICustomerFormReviewProps {
    isccDocument: ICustomerIscc;
    isccDocumentType: "ISCC";
}


const CustomerISCCDocumentData: React.FC<ICustomerFormReviewProps> = (props): JSX.Element => {
    const { t } = useTranslation(['contract', 'app']);
    const layoutMode = useSelector((state: RootState) => {
        return state.dsLayout.mode;
    });
    const { isccDocument, isccDocumentType } = props;
    const replaceEmpty = (value: string): string => {
        return value.length ? value : "-";
    }
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    const appUserProfile: IAppUserProfile | undefined = appUser?.userProfile;
    const [viewRejectionPopup, setViewRejectionPopup] =useState<boolean>(false);

const dispatch = useDispatch();
const navigate = useNavigate();
    const showIsccNotification = (operation: "approved" | "rejected" | "deleted", response?: { status?: ResponseStatus; code?: ResponseCode }) => {
        const isError = !response || response.status === ResponseStatus.ERROR;
        const isWarning = response?.code === ResponseCode.UNPROCESSABLE_CONTENT;
        const popUpAction: INotificationAction = {
            show: true,
            title: isError
                ? t("customer.customerIsccDocumentForm.operationNotifications.errorTitle")
                : isWarning
                    ? t("customer.customerIsccDocumentForm.operationNotifications.warningTitle")
                    : t("customer.customerIsccDocumentForm.operationNotifications.successTitle"),
            description: isError
                ? t("customer.customerIsccDocumentForm.operationNotifications.errorDescription")
                : isWarning
                    ? t("customer.customerIsccDocumentForm.operationNotifications.warningDescription")
                    : t(`customer.customerIsccDocumentForm.operationNotifications.${operation}`),
            status: isError ? "error" : isWarning ? "warning" : "confirm",
            onClose: () => dispatch(hideNotification())
        };
        dispatch(showNotification(popUpAction));
    };
    
    const approveIsccDocumnet = (row: string) => { //row 0,1,ecc
        const rowIndex = parseInt(row);
        let isccDocumnetToEdit = isccDocument;
        isccDocumnetToEdit.documents[0].status = BadgeStatus.APPROVED;
        putIsccDocumnetStatus(isccDocumnetToEdit)
            .then(response => {
                showIsccNotification("approved", response);
                navigate(RoutePath.CONTRACTS_CUSTOMER_INFO);
            })
            .catch(error => {
                console.log(error);
                showIsccNotification("approved");
            });
    }
    const [rejectionRow,setRejectionRow] = useState<number|undefined>(undefined);

    const rejectIsccDocument = (message: string) => {
        if(rejectionRow!==undefined){
            const rowIndex = rejectionRow;
            let isccDocumnetToEdit = isccDocument;
            isccDocumnetToEdit.documents[0].status = BadgeStatus.NOTAPPROVED;
            putIsccDocumnetStatus(isccDocumnetToEdit,message)
                .then(response => {
                    showIsccNotification("rejected", response);
                    navigate(RoutePath.CONTRACTS_CUSTOMER_INFO);
                })
                .catch(error => {
                    console.log(error);
                    showIsccNotification("rejected");
                });
        }
        
    }
    const editIsccDocumnet = (row: string) => {
        const rowIndex = parseInt(row);
        let isccDocumnetToEdit = isccDocument;
        console.log("editIsccDocumnet",isccDocumnetToEdit);
        navigate(`${RoutePath.CONTRACTS_CUSTOMER_ISCC}/${isccDocumnetToEdit.businessId}/${isccDocumnetToEdit.id}`);
    }
    const deleteIsccDocument = (row: string) => {
        const rowIndex = parseInt(row);
        let isccDocumentToEdit = isccDocument;
        deleteCustomerISCCDocumentAPI(isccDocumentToEdit.id)
            .then(response => {
                showIsccNotification("deleted", response);
                navigate(RoutePath.CONTRACTS_CUSTOMER_INFO);
            })
            .catch(error => {
                console.log(error);
                showIsccNotification("deleted");
            });
    }
    const downloadIsccDocumentDocument = (row: string) => {
         const rowIndex = parseInt(row);
        let isccDocumnetToEdit = isccDocument;
        downloadDocument(isccDocumnetToEdit.businessId, EntityType.ISCC_DOCUMENT, DocumentType.CUSTOMER_ISCC_DOCUMENT)
            .then((response) => {
                if(response.data.code===ResponseCode.UNPROCESSABLE_CONTENT){
                    showPopupError()
                }
                let file = new File(
                    [response.data],
                    "customerIsccDocument_" + DocumentType.CUSTOMER_ISCC_DOCUMENT + "_" + isccDocumnetToEdit.id + ".pdf"
                );
                saveAs(file);
             })
            .catch((error) => {
                showPopupError();
                console.log(error);
            });
    }


    const getTableRowsIsccDocuments = (): ITableRow[] => {
        let myRetArr: ITableRow[] = [];
        let test : ITableCell
        console.log("isccDocument",isccDocument);
        if (isccDocument && Array.isArray(isccDocument.documents)) {
            for (let i = 0; i < isccDocument.documents.length; i++) {
                    let tempObj: ITableRow = {
                        tableCells: [
                            { 
                                type: "text-badge", 
                                text: isccDocument.documents[i].name,
                                badgeStatus: isccDocument.documents[i].status===BadgeStatus.EXPIRED ? "error" : 
                                isccDocument.documents[i].status===BadgeStatus.TOAPPROVE ? "warning" : 
                                isccDocument.documents[i].status===BadgeStatus.APPROVED ? "confirm" : "error",
                            },
                            { 
                                type: "text", 
                                text: isccDocument.documents[i].expire !== null ? parseDateForDS(
                                moment
                                .unix(isccDocument.documents[i].expire as number)
                                .format(DATE_FORMAT),
                                IParseDateFormatType.DATE_FORMAT1
                                ) : ""
                                }
                        ],
                        //rightIcon: "icon-download",
                        "rightIconMenu": true,
                        "rightIconMenuData": (appUserRole===AppUserRole.ADMIN||appUserRole===AppUserRole.SALES_PROFILE) ? (
                            (isccDocument.documents[i].status === BadgeStatus.APPROVED||isccDocument.documents[i].status === BadgeStatus.NOTAPPROVED||isccDocument.documents[i].status === BadgeStatus.EXPIRED) ?
                            [
                                
                                {
                                    "actionLabel": t("general.buttons.modify",{ ns: "app" }),
                                    "actionAriaLabel": t("general.buttons.modify",{ ns: "app" }), //EDIT
                                    "actionDisabled": false,
                                },
                                {
                                    "actionLabel": t("general.buttons.removeElement",{ ns: "app", what: "" }),
                                    "actionAriaLabel": t("general.buttons.removeElement",{ ns: "app", what: "" }), // DELETE
                                    "actionDisabled": false,
                                },
                                {
                                    "actionLabel": t("general.buttons.download_short",{ ns: "app" }),
                                    "actionAriaLabel": t("general.buttons.download_short",{ ns: "app" }), //DOWNLOAD
                                    "actionDisabled": false,
                                },

                            ]
                            :
                            [
                                {
                                    "actionLabel": t("general.buttons.approve",{ ns: "app", what: "" }), //APPROVE
                                    "actionAriaLabel": t("general.buttons.approve",{ ns: "app", what: "" }),
                                    "actionDisabled": false,
                                    //"actionIcon": "icon-share"
                                },
                                {
                                    "actionLabel": t("general.buttons.reject",{ ns: "app", what: "" }), //REJECT/NON APPROVA
                                    "actionAriaLabel": t("general.buttons.reject",{ ns: "app", what: "" }),
                                    "actionDisabled": false,
                                },
                                {
                                    "actionLabel": t("general.buttons.modify",{ ns: "app" }),
                                    "actionAriaLabel": t("general.buttons.modify",{ ns: "app" }), //EDIT
                                    "actionDisabled": false,
                                },
                                {
                                    "actionLabel": t("general.buttons.removeElement",{ ns: "app", what: "" }),
                                    "actionAriaLabel": t("general.buttons.removeElement",{ ns: "app", what: "" }), // DELETE
                                    "actionDisabled": false,
                                },
                                {
                                    "actionLabel": t("general.buttons.download_short",{ ns: "app" }),
                                    "actionAriaLabel": t("general.buttons.download_short",{ ns: "app" }), //DOWNLOAD
                                    "actionDisabled": false,
                                },
                            ]
                        )
                        :
                        (
                            [
                                {
                                    "actionLabel": t("general.buttons.modify",{ ns: "app" }),
                                    "actionAriaLabel": t("general.buttons.modify",{ ns: "app" }), //EDIT
                                    "actionDisabled": false,
                                },
                                {
                                    "actionLabel": t("general.buttons.removeElement",{ ns: "app", what: "" }),
                                    "actionAriaLabel": t("general.buttons.removeElement",{ ns: "app", what: "" }), // DELETE
                                    "actionDisabled": false,
                                },
                                {
                                    "actionLabel": t("general.buttons.download_short",{ ns: "app" }),
                                    "actionAriaLabel": t("general.buttons.download_short",{ ns: "app" }), //DOWNLOAD
                                    "actionDisabled": false,
                                }
                            ]
                        )
                        
                    };
                    myRetArr.push(tempObj);           
            }
        }
        return myRetArr;
    };
    const myTableConfigIsccDocuments: ITableConfig = {
            ...getDSTableSharedElements(),
            tableHeader: {
                tableCellsHeader: [
                    getTableCellsHeaderSimple(t("customer.customerIsccDocumentForm.table_1") as string,"col1","75%","left"),
                    getTableCellsHeaderSimple(t("customer.customerIsccDocumentForm.table_4") as string,"col2","25%","left"),
                ],
                hasSearchBox: true,
            },
            tableRows: getTableRowsIsccDocuments()
    };
    
    return (
    <>
        <div className="listTableContainer" style={{ background: "" }}>
            {isccDocument && isccDocument.documents ? (
                <>
                <p
                                    style={{
                                    fontWeight: "bold",
                                    fontSize: "90%",
                                    color:
                                        layoutMode === DsLayout.DARK_MODE
                                        ? "white"
                                        : "#0e2852",
                                }}
                                >
                                {t("customer.customerIsccDocumentForm.title_10") as string}
                                </p>{" "}
                    {
                        <Table 
                            tableConfig={myTableConfigIsccDocuments} 
                            style={{}}
                            onColumnSorting={(event:Event)=>{
                                //console.log(event)
                            }}
                            onInputSearchBarChange={(event:Event)=>{
                                console.log((event as CustomEvent).detail.searchedText + " - " + (event as CustomEvent).detail.cells)
                            }}
                            onClickRightAction={(event:Event)=>{
                                console.log(event)
                                //navigate(contractList[(event as CustomEvent).detail.row].contractId)
                            }}
                            onButtonItemCellClick={(event:Event)=>{
                                console.log(event)
                            }}

                            
        
                            onClickKebabAction1={(event:Event)=>{ 
                                if(appUserRole===AppUserRole.CUSTOMER){
                                    editIsccDocumnet((event as CustomEvent).detail.row);
                                }else if (appUserRole===AppUserRole.ADMIN || appUserRole===AppUserRole.SALES_PROFILE){
                                    if(isccDocument.documents[0].status === BadgeStatus.APPROVED||isccDocument.documents[0].status === BadgeStatus.NOTAPPROVED||isccDocument.documents[0].status === BadgeStatus.EXPIRED){
                                        editIsccDocumnet((event as CustomEvent).detail.row);
                                    }else{
                                        approveIsccDocumnet((event as CustomEvent).detail.row);
                                    }
                                    
                                }
                            }}
                            onClickKebabAction2={(event:Event)=>{ 
                               if(appUserRole===AppUserRole.CUSTOMER ){
                                deleteIsccDocument((event as CustomEvent).detail.row);
                                    //
                                }else if (appUserRole===AppUserRole.ADMIN || appUserRole===AppUserRole.SALES_PROFILE){
                                    if(isccDocument.documents[0].status === BadgeStatus.APPROVED||isccDocument.documents[0].status === BadgeStatus.NOTAPPROVED||isccDocument.documents[0].status === BadgeStatus.EXPIRED){
                                        deleteIsccDocument((event as CustomEvent).detail.row);
                                    }else{
                                        setRejectionRow(parseInt((event as CustomEvent).detail.row));
                                        setViewRejectionPopup(true);
                                    }
                                }
                            }}
                            onClickKebabAction3={(event:Event)=>{ 
                                if(appUserRole===AppUserRole.CUSTOMER ){
                                    downloadIsccDocumentDocument((event as CustomEvent).detail.row);
                                }else if (appUserRole===AppUserRole.ADMIN || appUserRole===AppUserRole.SALES_PROFILE){
                                    if(isccDocument.documents[0].status === BadgeStatus.APPROVED||isccDocument.documents[0].status === BadgeStatus.NOTAPPROVED||isccDocument.documents[0].status === BadgeStatus.EXPIRED){
                                        downloadIsccDocumentDocument((event as CustomEvent).detail.row);
                                    }else{
                                        editIsccDocumnet((event as CustomEvent).detail.row);
                                    }
                                }
                            }}
                            onClickKebabAction4={(event:Event)=>{ 
                               if(appUserRole===AppUserRole.CUSTOMER ){
                                    //
                                }else if (appUserRole===AppUserRole.ADMIN || appUserRole===AppUserRole.SALES_PROFILE){
                                    if(isccDocument.documents[0].status === BadgeStatus.APPROVED||isccDocument.documents[0].status === BadgeStatus.NOTAPPROVED||isccDocument.documents[0].status === BadgeStatus.EXPIRED){
                                        //
                                    }else{
                                        deleteIsccDocument((event as CustomEvent).detail.row);
                                    }
                                    
                                }
                                           
                            }}
                            onClickKebabAction5={(event:Event)=>{ 
                              if(appUserRole===AppUserRole.CUSTOMER ){
                                    //
                                }else if (appUserRole===AppUserRole.ADMIN || appUserRole===AppUserRole.SALES_PROFILE){
                                    if(isccDocument.documents[0].status === BadgeStatus.APPROVED||isccDocument.documents[0].status === BadgeStatus.NOTAPPROVED||isccDocument.documents[0].status === BadgeStatus.EXPIRED){
                                        //
                                    }else{
                                        downloadIsccDocumentDocument((event as CustomEvent).detail.row);
                                    }
                                }
                            }}
                        />
                    }
                    {getDelegationLegend(true)}
                </>
            ) : (<>
                 <p
                                    style={{
                                    fontWeight: "bold",
                                    fontSize: "90%",
                                    color:
                                        layoutMode === DsLayout.DARK_MODE
                                        ? "white"
                                        : "#0e2852",
                                }}
                                >
                                {t("customer.customerIsccDocumentForm.title_10") as string}
                                </p>{" "}
                <p
                    style={{
                        color:
                            layoutMode === DsLayout.DARK_MODE
                                ? "white"
                                : "black",
                    }}
                >
                    {t("transporter.transportData.noDelegationFound")}
                    {/*Non sono presenti deleghe a sistema*/}
                </p></>
            )}
        </div>
        {viewRejectionPopup && (
                <>
                    <DialogMessage
                        title={t(
                            "transporter.transporterData.rejectDialog.delegation.title"
                        )} 
                        subtitle={t(
                            "transporter.transporterData.rejectDialog.delegation.subTitle"
                        )} 
                        textareaLabel={t(
                            "drivers.driverData.rejectDialog.textareaLabel"
                        )}
                        textAreaPlaceholder={t(
                            "drivers.driverData.rejectDialog.txtAreaPlaceholder"
                        )}
                        textareaDescription={t(
                            "drivers.driverData.rejectDialog.textareaDescription"
                        )}
                        submitButtonLabel={t(
                            "drivers.driverData.rejectDialog.submitButtonLabel"
                        )}
                        icon={""}
                        type={EntityType.ISCC_DOCUMENT}
                        onClose={() => setViewRejectionPopup(false)}
                         onClick={rejectIsccDocument}
                    />
                </>
            )}
    </>
    )
}
export default CustomerISCCDocumentData;

function showPopupError() {
    throw new Error("Function not implemented.");
}
